import { persistStore } from 'redux-persist';
import { initMessageListener } from 'redux-state-sync';
import { crossBrowserListener } from './crossBrowserListener';
import { persistConfig, store } from './rootReducer';

initMessageListener(store);

const storePersister = persistStore(store);

if (typeof module.hot !== 'undefined') {
    module.hot.accept('./rootReducer', () => store.replaceReducer(require('./rootReducer').rootReducer));
}

window.addEventListener('storage', crossBrowserListener(store, persistConfig));

export { store, storePersister };
